import {API_CLIENT_ID, API_CLIENT_SECRET, API_URL, API_GRANT_TYPE} from './Config';
import store from '../store';
export function startLoading(){
    return{type:'LOADIND_START'};
}

export function endLoading(){
    return{type:'LOADIND_END'};
}

export function SnackBar(show,message,varient){
    return {
                type:'SHOW_ALERT',
                show : show,
                message : message,
                varient:varient,
           } ;

}



export function ShowLoadingSpinner(field,status) {
  return {
      type: 'SHOW_LOADER',
      field: field,
      status:status
  }
}
export function pageGifLoader(bool) {
  return {
      type: 'STORE_PAGE_LOADING',bool
  }
}


export function ShowAlert(show,message,varient){

  return function(dispatch){
      dispatch(SnackBar(show,message,varient));
  }

}

export function handleHTTPError(response){
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

